var $e203254b4140c831$exports = {};
$e203254b4140c831$exports = {
    "invalidSelection": (args, formatter)=>`Atlas\u{12B}tais(-ie) ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} nav pieejams(-i).`
};


export {$e203254b4140c831$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
